import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

const Footer = () => {
    return (
        <footer 
            className='flex lap:flex-col lap:gap-y-12 items-center justify-between mob:justify-center px-8 tab:px-4 pt-10 pb-20'
        >

            <motion.img 
                src={logo} 
                alt="Logo" 
                className='w-28'
                initial='hidden'
                whileInView='visible'
                viewport={{ once: true, }}
                variants={{
                    hidden: { opacity: 0, x: 75 },
                    visible: { opacity: 1, x: 0 }
                }}
                transition={{ duration: 0.5, delay: 0.5, type: 'spring', stiffness: 130 }}
            />

            <ul 
                className='flex mob:flex-col mob:gap-y-12 items-center justify-around list-none gap-x-12'
            >
                {
                    ['Support', 'Privacy Policy', 'Terms and Condition'].map((item, index) => (
                        <motion.li
                            key={index}
                            className="text-[17px] text-greys cursor-pointer animi ease-in-out hover:text-blue"
                            initial='hidden'
                            whileInView='visible'
                            viewport={{ once: true, }}
                            variants={{
                                hidden: { opacity: 0, left: -100 },
                                visible: { opacity: 1, left: 0 }
                            }}
                            transition={{ duration: 0.5, delay: 0.5, type: 'spring', stiffness: 130 }}
                                    >
                            {item}
                        </motion.li>
                    ))
                }
            </ul>

            <motion.p 
                className='text-greys text-lg'
                initial='hidden'
                whileInView='visible'
                viewport={{ once: true, }}
                variants={{
                    hidden: { opacity: 0, x: 75 },
                    visible: { opacity: 1, x: 0 }
                }}
                transition={{ duration: 0.5, delay: 0.5, type: 'spring', stiffness: 130 }}
            >
                &copy;2025 Enver. All Right Reserved
            </motion.p>

        </footer>
    );
}
 
export default Footer;